import { render } from "./TimeAdmin.vue?vue&type=template&id=0aacd052&scoped=true"
import script from "./TimeAdmin.vue?vue&type=script&lang=js"
export * from "./TimeAdmin.vue?vue&type=script&lang=js"

import "./TimeAdmin.vue?vue&type=style&index=0&id=0aacd052&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0aacd052"]])

export default __exports__